import { darken, lighten, makeStyles, Paper } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT, REALTIME_INTERVAL_SECONDS_U } from '../../constants';
import { dataAxureFetch } from '../../helpers/fetch';


const { color_nav_letter, color_nav, color_back } = COLORS_PROJECT;

const useStyles = makeStyles((theme) => ({
    sizeChart: {
        width: '100%',
        height: '350px',
        backgroundColor: lighten(color_back, 0.8),//lighten(color_back, 0.5),
    },
}));

const colorChart = '#00416A';

export const TransitionCurve = ({ filters, getDataToggle, realtime,namePoint="AX_1", size = 350,historic=false }) => {
    const uid = useSelector((state) => state.auth.uid);
    
    const [dataChart, setDataChart] = useState([]);

    const classes = useStyles();

    useEffect(() => {
        if (realtime) {
            getGraphDataRealtime();
            let unmounted = false;
            const interval = setInterval(() => {
                if(!unmounted){
                    getGraphDataRealtime();
                }
            },REALTIME_INTERVAL_SECONDS_U *1000);
            return () => {
                unmounted= true
                clearInterval(interval);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [namePoint,realtime]);

    useEffect(() => {
        if (getDataToggle || historic){
            getGraphDataHistoric()
        }
        
        // if (getDataToggle) {
        //     getGraphDataHistoric();
        //     let unmounted = false;
        //     const interval = setInterval(() => {
        //         if(!unmounted){
        //             getGraphDataRealtime();
        //         }
        //     },1000);
        //     return () => {
        //         unmounted= true
        //         clearInterval(interval);
        //     }
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [namePoint]);

    /**
     * To get data in Real time
     */
    const getGraphDataRealtime = async () => {
        try {
            const response = await dataAxureFetch(
                {
                    nomSCE: namePoint,
                    idCliente: uid
                },
                'POST'
            );
            //console.log('respuesta',response)
            setDataChart(response);
        } catch (error) {
            console.log(error);
        }
    };

    /**
     * To get data for the historic
     */
    const getGraphDataHistoric = async () => {
        const response = await dataAxureFetch(
            {
                nomSCEH: namePoint,
                idCliente: uid,
                fecIConsCEH: filters.startDate,
                fecFConsCEH: filters.endDate,
            },
            'POST'
        );
        if (response) {
            setDataChart(response);
        }
    };

    /**
     * To build line graph
     */
    const getDataLine = () => {
        let dataX = [];
        let dataY = [];

        if (dataChart===null) {
            dataX = [];
            dataY = [];
        }else{
            dataChart.forEach((element) => {
                const time = element.fecha;
                const hour = time.substr(11,5);
                dataX.push(hour);
            });
            dataChart.forEach((element) => dataY.push(element.ce));
        }


        const data = {
            labels: dataX,
            datasets: [
                {
                    label: `Carga electrica ${namePoint}`,
                    fill: false,
                    borderColor: colorChart,
                    hoverBorderColor: (colorChart, 0.4),
                    data: dataY,
                },
            ],
        };

        return data;
    };

    const options = {
        maintainAspectRatio: false,
        responsive: true,
        title: {
            display: true,
            text: `Campo eléctrico ${namePoint}`,
            fontSize: 20,
            fontColor: darken(color_nav, 0.45),
        },
        legend: {
            display: true,
            position: 'top',
            labels: {
                fontColor: darken(color_nav_letter, 1),
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: {
                        color: color_back,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'Horas(h)'
                    },
                },
            ],
            yAxes: [
                {
                    
                    gridLines: {
                        color: color_back,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: 'V/m'
                    },
                },
            ],
        },
        elements: {
            point: {
                radius: 0,
            },
        },
    };

    // console.log(namePoint, dataChart)

    return (
        <Paper className={classes.sizeChart} style={{ height: size }}>
            <Line data={getDataLine()} options={options} />
        </Paper>
    );
};

TransitionCurve.propTypes = {
    filters: PropTypes.object,
    getDataToggle: PropTypes.bool,
    realtime: PropTypes.bool.isRequired,
    size: PropTypes.number,
    historic: PropTypes.bool,
};
